import Phaser from 'phaser';
import { sounds } from '../audio/SoundEffects';
import { progression } from '../game/Progression';
import { ShopModal } from '../ui/ShopModal';

export class MenuScene extends Phaser.Scene {
  constructor() {
    super({ key: 'MenuScene' });
  }

  create() {
    console.log('[MenuScene] create start');
    const { width, height } = this.scale;

    // Background Image: Zelvis King of Rock 'n Olympus
    if (this.textures.exists('zelvis_hero')) {
      const bg = this.add.image(width / 2, height / 2, 'zelvis_hero');
      const scaleX = width / bg.width;
      const scaleY = height / bg.height;
      const scale = Math.max(scaleX, scaleY);
      bg.setScale(scale);
      bg.setAlpha(0.72);
    }

    // Dark gradient overlay for readability
    const overlay = this.add.graphics();
    overlay.fillGradientStyle(0x0f172a, 0x0f172a, 0x020617, 0x020617, 0.4, 0.4, 0.95, 0.95);
    overlay.fillRect(0, 0, width, height);

    // Audio Mute/Unmute Toggle in top-right corner
    const isMuted = sounds.isMuted;
    const soundToggle = this.add.text(width - 20, 16, isMuted ? '🔇' : '🔊', {
      fontSize: '24px',
      backgroundColor: '#1e293b',
      padding: { x: 7, y: 4 }
    }).setOrigin(1, 0).setInteractive({ useHandCursor: true });

    soundToggle.on('pointerdown', () => {
      sounds.isMuted = !sounds.isMuted;
      sounds.music.setMuted(sounds.isMuted);
      soundToggle.setText(sounds.isMuted ? '🔇' : '🔊');
    });

    // APK Download button in top-left corner
    const apkButton = this.add.text(20, 16, '📱 APK', {
      fontFamily: 'Arial, sans-serif',
      fontSize: '14px',
      fontStyle: 'bold',
      color: '#38bdf8',
      backgroundColor: '#1e293b',
      padding: { x: 9, y: 6 }
    }).setOrigin(0, 0).setInteractive({ useHandCursor: true });

    apkButton.on('pointerdown', () => {
      window.open('zelvis-antigravity.apk', '_blank');
    });

    // Title Header Glass Card
    const headerW = Math.min(width - 40, 410);
    const headerBg = this.add.graphics();
    headerBg.fillStyle(0x090d16, 0.88);
    headerBg.fillRoundedRect(width / 2 - headerW / 2, 54, headerW, 108, 16);
    headerBg.lineStyle(2, 0xf59e0b, 0.85);
    headerBg.strokeRoundedRect(width / 2 - headerW / 2, 54, headerW, 108, 16);

    const titleGlow = this.add.text(width / 2, 84, '⚡ ZELVIS ⚡', {
      fontFamily: 'Impact, Arial Black, sans-serif',
      fontSize: '40px',
      color: '#facc15',
      stroke: '#9a3412',
      strokeThickness: 5,
      align: 'center'
    }).setOrigin(0.5);

    this.tweens.add({
      targets: titleGlow,
      scaleX: 1.03,
      scaleY: 1.03,
      duration: 1200,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut'
    });

    this.add.text(width / 2, 120, 'ANTI-GRAVITY ROCKSTAR', {
      fontFamily: 'Impact, Arial Black, sans-serif',
      fontSize: '20px',
      color: '#38bdf8',
      stroke: '#0369a1',
      strokeThickness: 3,
      letterSpacing: 2,
      align: 'center'
    }).setOrigin(0.5);

    this.add.text(width / 2, 144, "KING OF ROCK 'N OLYMPUS", {
      fontFamily: 'Arial, sans-serif',
      fontSize: '11px',
      color: '#fbbf24',
      fontStyle: 'bold',
      letterSpacing: 2,
      align: 'center'
    }).setOrigin(0.5);

    // High Score & Bank Header Pill
    const statsPill = this.add.graphics();
    statsPill.fillStyle(0x0f172a, 0.88);
    statsPill.fillRoundedRect(width / 2 - 165, 170, 330, 32, 16);
    statsPill.lineStyle(1.5, 0x38bdf8, 0.7);
    statsPill.strokeRoundedRect(width / 2 - 165, 170, 330, 32, 16);

    const highScore = localStorage.getItem('zelvis_highscore') || '0';
    this.add.text(width / 2, 186, `🏆 RECORD: ${highScore} PTS  |  📀 BANK: ${progression.getBankVinyls()}`, {
      fontFamily: 'Arial, sans-serif',
      fontSize: '13px',
      color: '#ffffff',
      fontStyle: 'bold',
      align: 'center'
    }).setOrigin(0.5);

    // LEVEL SELECTION PANEL (Act 1: 1-4, Act 2: 5-8, Act 3: 9-11)
    this.currentAct = 1;

    const colLeft = width / 2 - 100;
    const colRight = width / 2 + 100;

    // Act Selector Tabs (Segmented rounded pills)
    const tabY = 222;
    const tabAct1 = this.add.container(width / 2 - 120, tabY);
    const tabAct1Bg = this.add.graphics();
    tabAct1Bg.fillStyle(0x0284c7, 1);
    tabAct1Bg.fillRoundedRect(-56, -17, 112, 34, 10);
    tabAct1Bg.lineStyle(2, 0x38bdf8, 1);
    tabAct1Bg.strokeRoundedRect(-56, -17, 112, 34, 10);

    const tabAct1Hit = this.add.zone(0, 0, 112, 34).setInteractive({ useHandCursor: true });
    const tabAct1Text = this.add.text(0, 0, '⚡ ACT I (1-4)', {
      fontFamily: 'Impact, Arial Black, sans-serif',
      fontSize: '12px',
      color: '#ffffff'
    }).setOrigin(0.5);
    tabAct1.add([tabAct1Bg, tabAct1Text, tabAct1Hit]);

    const tabAct2 = this.add.container(width / 2, tabY);
    const tabAct2Bg = this.add.graphics();
    tabAct2Bg.fillStyle(0x1e293b, 1);
    tabAct2Bg.fillRoundedRect(-56, -17, 112, 34, 10);
    tabAct2Bg.lineStyle(2, 0x64748b, 1);
    tabAct2Bg.strokeRoundedRect(-56, -17, 112, 34, 10);

    const tabAct2Hit = this.add.zone(0, 0, 112, 34).setInteractive({ useHandCursor: true });
    const tabAct2Text = this.add.text(0, 0, '🌌 ACT II (5-8)', {
      fontFamily: 'Impact, Arial Black, sans-serif',
      fontSize: '12px',
      color: '#94a3b8'
    }).setOrigin(0.5);
    tabAct2.add([tabAct2Bg, tabAct2Text, tabAct2Hit]);

    const tabAct3 = this.add.container(width / 2 + 120, tabY);
    const tabAct3Bg = this.add.graphics();
    tabAct3Bg.fillStyle(0x1e293b, 1);
    tabAct3Bg.fillRoundedRect(-56, -17, 112, 34, 10);
    tabAct3Bg.lineStyle(2, 0x64748b, 1);
    tabAct3Bg.strokeRoundedRect(-56, -17, 112, 34, 10);

    const tabAct3Hit = this.add.zone(0, 0, 112, 34).setInteractive({ useHandCursor: true });
    const tabAct3Text = this.add.text(0, 0, '👑 ACT III (9-11)', {
      fontFamily: 'Impact, Arial Black, sans-serif',
      fontSize: '12px',
      color: '#94a3b8'
    }).setOrigin(0.5);
    tabAct3.add([tabAct3Bg, tabAct3Text, tabAct3Hit]);

    const row1Y = 276;
    const row2Y = 344;

    // Container for Act 1 buttons
    this.act1Container = this.add.container(0, 0);

    // Button: LEVEL 1 (OLYMPUS ARENA)
    this.act1Container.add(this.createLevelButton(
      colLeft,
      row1Y,
      'STAGE 1: OLYMPUS',
      '⚡ Sky Arena & Marble',
      0x0284c7,
      0x38bdf8,
      () => this.startLevel(1),
      192,
      58,
      '14.5px'
    ));

    // Button: LEVEL 2 (TARTARUS ABYSS)
    this.act1Container.add(this.createLevelButton(
      colRight,
      row1Y,
      'STAGE 2: TARTARUS',
      '🔥 Obsidian Metal Rave',
      0x7e22ce,
      0xc026d3,
      () => this.startLevel(2),
      192,
      58,
      '14.5px'
    ));

    // Button: LEVEL 3 (HEPHAESTUS CYBER-FORGE)
    this.act1Container.add(this.createLevelButton(
      colLeft,
      row2Y,
      'STAGE 3: CYBER FORGE',
      '🔨 Molten Bronze & Gears',
      0xc2410c,
      0xf97316,
      () => this.startLevel(3),
      192,
      58,
      '14px'
    ));

    // Button: LEVEL 4 (COSMIC OLYMPUS APOTHEOSIS)
    this.act1Container.add(this.createLevelButton(
      colRight,
      row2Y,
      'STAGE 4: COSMOS',
      '🌌 Celestial Apotheosis',
      0x4338ca,
      0x818cf8,
      () => this.startLevel(4),
      192,
      58,
      '14.5px'
    ));

    // Container for Act 2 buttons
    this.act2Container = this.add.container(0, 0);
    this.act2Container.setVisible(false);

    // Button: LEVEL 5 (ATLANTIS NEON ABYSS)
    this.act2Container.add(this.createLevelButton(
      colLeft,
      row1Y,
      'STAGE 5: ATLANTIS',
      '🌊 Cyber Ocean & Coral',
      0x0891b2,
      0x22d3ee,
      () => this.startLevel(5),
      192,
      58,
      '14.5px'
    ));

    // Button: LEVEL 6 (DIONYSUS NEON RAVE)
    this.act2Container.add(this.createLevelButton(
      colRight,
      row1Y,
      'STAGE 6: DIONYSUS',
      '🍇 Neon Rave & Synth-Wine',
      0x9333ea,
      0xfacc15,
      () => this.startLevel(6),
      192,
      58,
      '14.5px'
    ));

    // Button: LEVEL 7 (ARES ORBITAL CITADEL)
    this.act2Container.add(this.createLevelButton(
      colLeft,
      row2Y,
      'STAGE 7: ARES CITADEL',
      '⚔️ War Fortress & Plasma',
      0xb91c1c,
      0xef4444,
      () => this.startLevel(7),
      192,
      58,
      '14px'
    ));

    // Button: LEVEL 8 (KRONOS CHRONO-SINGULARITY)
    this.act2Container.add(this.createLevelButton(
      colRight,
      row2Y,
      'STAGE 8: KRONOS',
      '⌛ Chrono-Singularity Climax',
      0xb45309,
      0xfde047,
      () => this.startLevel(8),
      192,
      58,
      '14px'
    ));

    // Container for Act 3 buttons (Stages 9, 10, 11)
    this.act3Container = this.add.container(0, 0);
    this.act3Container.setVisible(false);

    // Button: LEVEL 9 (RIVER STYX SPECTRAL RUN)
    this.act3Container.add(this.createLevelButton(
      colLeft,
      row1Y,
      'STAGE 9: STYX',
      '💀 Spectral River & Wraith',
      0x065f46,
      0x10b981,
      () => this.startLevel(9),
      192,
      58,
      '14.5px'
    ));

    // Button: LEVEL 10 (APOLLO SOLAR HYPER-DRIVE)
    this.act3Container.add(this.createLevelButton(
      colRight,
      row1Y,
      'STAGE 10: APOLLO',
      '☀️ Helios Solar Flare',
      0xb45309,
      0xf59e0b,
      () => this.startLevel(10),
      192,
      58,
      '14.5px'
    ));

    // Button: LEVEL 11 (CHAOS PRIMORDIAL GENESIS)
    this.act3Container.add(this.createLevelButton(
      width / 2,
      row2Y,
      'STAGE 11: CHAOS GENESIS',
      '👑 Primordial Big Bang Climax',
      0x581c87,
      0xa855f7,
      () => this.startLevel(11),
      394,
      58,
      '16px'
    ));

    const redrawTab = (g, bgCol, strokeCol) => {
      g.clear();
      g.fillStyle(bgCol, 1);
      g.fillRoundedRect(-60, -17, 120, 34, 10);
      g.lineStyle(2, strokeCol, 1);
      g.strokeRoundedRect(-60, -17, 120, 34, 10);
    };

    const switchAct = (actNum) => {
      this.currentAct = actNum;
      sounds.playCoin();

      redrawTab(tabAct1Bg, 0x1e293b, 0x64748b);
      redrawTab(tabAct2Bg, 0x1e293b, 0x64748b);
      redrawTab(tabAct3Bg, 0x1e293b, 0x64748b);
      [tabAct1Text, tabAct2Text, tabAct3Text].forEach(t => t.setColor('#94a3b8'));

      this.act1Container.setVisible(false);
      this.act2Container.setVisible(false);
      this.act3Container.setVisible(false);

      if (actNum === 1) {
        redrawTab(tabAct1Bg, 0x0284c7, 0x38bdf8);
        tabAct1Text.setColor('#ffffff');
        this.act1Container.setVisible(true);
      } else if (actNum === 2) {
        redrawTab(tabAct2Bg, 0x7e22ce, 0xfacc15);
        tabAct2Text.setColor('#ffffff');
        this.act2Container.setVisible(true);
      } else if (actNum === 3) {
        redrawTab(tabAct3Bg, 0x065f46, 0x34d399);
        tabAct3Text.setColor('#ffffff');
        this.act3Container.setVisible(true);
      }
    };

    tabAct1Hit.on('pointerdown', () => switchAct(1));
    tabAct2Hit.on('pointerdown', () => switchAct(2));
    tabAct3Hit.on('pointerdown', () => switchAct(3));

    // Button: ROCKSTAR PERK SHOP & MISSIONS
    this.createLevelButton(
      width / 2,
      416,
      `🛍️ ROCKSTAR SHOP (📀 ${progression.getBankVinyls()})`,
      'Perks: Shield, Magnet, Overdrive & Missions',
      0xb45309,
      0xfacc15,
      () => new ShopModal(this, () => this.scene.restart()),
      394,
      54,
      '16px'
    );

    // Gameplay guide box
    const guideBox = this.add.graphics();
    guideBox.fillStyle(0x0f172a, 0.88);
    guideBox.fillRoundedRect(width / 2 - 185, height - 200, 370, 115, 14);
    guideBox.lineStyle(1.8, 0x38bdf8, 0.8);
    guideBox.strokeRoundedRect(width / 2 - 185, height - 200, 370, 115, 14);

    this.add.text(width / 2, height - 186, '⚡ HOW TO PLAY & WIN ⚡', {
      fontFamily: 'Arial, sans-serif',
      fontSize: '13px',
      color: '#facc15',
      fontStyle: 'bold'
    }).setOrigin(0.5);

    const hints = [
      '• Tap [ANTI-GRAV] or Space to flip gravity',
      '• Tap [SLIDE] to knee-slide under hazards',
      '• Fill Overdrive (100%) to SHRED through spikes!',
      '• Graze near hazards for CLOSE CALL combos!'
    ];

    hints.forEach((hint, idx) => {
      this.add.text(width / 2 - 170, height - 165 + (idx * 20), hint, {
        fontFamily: 'Arial, sans-serif',
        fontSize: '11px',
        color: '#e2e8f0'
      });
    });

    // Keyboard support
    this.input.keyboard.on('keydown-ONE', () => this.startLevel(1));
    this.input.keyboard.on('keydown-TWO', () => this.startLevel(2));
    this.input.keyboard.on('keydown-THREE', () => this.startLevel(3));
    this.input.keyboard.on('keydown-FOUR', () => this.startLevel(4));
    this.input.keyboard.on('keydown-FIVE', () => this.startLevel(5));
    this.input.keyboard.on('keydown-SIX', () => this.startLevel(6));
    this.input.keyboard.on('keydown-SEVEN', () => this.startLevel(7));
    this.input.keyboard.on('keydown-EIGHT', () => this.startLevel(8));
    this.input.keyboard.on('keydown-NINE', () => this.startLevel(9));
    this.input.keyboard.on('keydown-ZERO', () => this.startLevel(10));
    this.input.keyboard.on('keydown-P', () => this.startLevel(11));
    this.input.keyboard.on('keydown-SPACE', () => this.startLevel(1));
    this.input.keyboard.on('keydown-ENTER', () => this.startLevel(1));
  }

  createLevelButton(x, y, title, subtitle, color, borderColor, onClick, btnWidth = 192, btnHeight = 58, titleSize = '14.5px') {
    const btn = this.add.container(x, y);

    // Rounded card background
    const bg = this.add.graphics();
    bg.fillStyle(0x0b1120, 0.92);
    bg.fillRoundedRect(-btnWidth / 2, -btnHeight / 2, btnWidth, btnHeight, 10);
    bg.lineStyle(2, borderColor, 0.85);
    bg.strokeRoundedRect(-btnWidth / 2, -btnHeight / 2, btnWidth, btnHeight, 10);

    // Left accent bar
    const barW = 4;
    bg.fillStyle(borderColor, 1);
    bg.fillRoundedRect(-btnWidth / 2 + 2, -btnHeight / 2 + 6, barW, btnHeight - 12, 2);

    // Interactive zone
    const hitZone = this.add.zone(0, 0, btnWidth, btnHeight).setInteractive({ useHandCursor: true });

    const t = this.add.text(-btnWidth / 2 + 14, -9, title, {
      fontFamily: 'Impact, Arial Black, sans-serif',
      fontSize: titleSize,
      color: '#ffffff'
    }).setOrigin(0, 0.5);

    const sub = this.add.text(-btnWidth / 2 + 14, 12, subtitle, {
      fontFamily: 'Arial, sans-serif',
      fontSize: '11px',
      color: '#cbd5e1'
    }).setOrigin(0, 0.5);

    btn.add([bg, t, sub, hitZone]);

    // Responsive hover and click feedback
    hitZone.on('pointerover', () => {
      this.tweens.add({
        targets: btn,
        scaleX: 1.03,
        scaleY: 1.03,
        duration: 100,
        ease: 'Quad.easeOut'
      });
      bg.clear();
      bg.fillStyle(0x131d33, 0.96);
      bg.fillRoundedRect(-btnWidth / 2, -btnHeight / 2, btnWidth, btnHeight, 10);
      bg.lineStyle(2.5, borderColor, 1);
      bg.strokeRoundedRect(-btnWidth / 2, -btnHeight / 2, btnWidth, btnHeight, 10);
      bg.fillStyle(borderColor, 1);
      bg.fillRoundedRect(-btnWidth / 2 + 2, -btnHeight / 2 + 6, barW, btnHeight - 12, 2);
    });

    hitZone.on('pointerout', () => {
      this.tweens.add({
        targets: btn,
        scaleX: 1.0,
        scaleY: 1.0,
        duration: 100,
        ease: 'Quad.easeOut'
      });
      bg.clear();
      bg.fillStyle(0x0b1120, 0.92);
      bg.fillRoundedRect(-btnWidth / 2, -btnHeight / 2, btnWidth, btnHeight, 10);
      bg.lineStyle(2, borderColor, 0.85);
      bg.strokeRoundedRect(-btnWidth / 2, -btnHeight / 2, btnWidth, btnHeight, 10);
      bg.fillStyle(borderColor, 1);
      bg.fillRoundedRect(-btnWidth / 2 + 2, -btnHeight / 2 + 6, barW, btnHeight - 12, 2);
    });

    hitZone.on('pointerdown', () => {
      btn.setScale(0.96);
      this.time.delayedCall(70, () => {
        btn.setScale(1.0);
        onClick();
      });
    });

    return btn;
  }

  startLevel(levelNumber) {
    sounds.init();
    sounds.playRockChord();
    this.scene.start('GameScene', { level: levelNumber });
  }
}
